<template>
  <div class="container" v-if="isLoggedIn">
    <!-- 서브상단영역 -->
    <Banner
      title="Activity"
      subtitle="Activity"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />
    <!-- //서브상단영역 -->

    <BoardNavbar />

    <div class="width_wrap">
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">재능진로전공직업 탐색 프로젝트</h1>
        <!-- //서브 타이틀영역 -->

        <div class="menu-A-read-wrap">
          <div>
            <ul class="line line4">
              <li>PUTT2.0 기반 진로탐색 프로젝트</li>
              <li>
                <dl class="line2">
                  <dt>제목</dt>
                  <dd>“청소년 문화공간을 건립하다!”</dd>
                </dl>
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                <figure>
                  <n-space justify="center">
                    <img
                    src=@/assets/thum_img/kp708b/sub4_1/5fd21a0f0f0639a690297ef6329cb2fc_water__c1_w280_h397.jpg
                    alt="">
                  </n-space>
                </figure>
              </li>
              <li>
                <dl>
                  <dt>목적</dt>
                  <dd>
                    본 활동은 학생이 자신의 꿈, 가치, 관심, 놀이 등을 실제
                    세상에 구현하기 위한 창작 활동으로, <br />
                    이 과정을 통해 재능 발견과 함께, 최적의 진로를 탐색하도록
                    하는 데 목적이 있다.
                  </dd>
                </dl>

                <dl>
                  <dt>목표</dt>
                  <dd>
                    목표 1. (강의를 들으면서) 세상 이해 및 자기 이해를 통해
                    자기개념을 정립한다.<br />
                    목표 2. 팀별로, 평소에 관심이 있거나 재능을 발휘, 구현하고
                    싶은 문화공간을 검색, 조사, 제안, 논의, 선택한다.<br />
                    목표 3. 팀 구성원들이 재능을 발휘하여 성취를 경험할 수 있는
                    특정 문화공간을 설계, 건립 계획을 세운다. <br />
                    목표 4. 팀별로 ‘청소년 문화공간 건립 계획서’를 작성하여,
                    발표, 또래평가를 한다.
                  </dd>
                </dl>

                <dl>
                  <dt>대상</dt>
                  <dd>중1 – 중3</dd>
                </dl>

                <dl class="line2">
                  <dt>시간</dt>
                  <dd>6시간 (사전 1시간ㅣ집합 5시간)</dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line line4">
              <li>JIGSAW 수업</li>
              <li>
                <dl class="line2">
                  <dt>재료</dt>
                  <dd>
                    • 자료 1. 팀 구성: PUTT2.0 결과를 기반으로, 팀(4인1팀)을
                    구성(팀 내, 다양한 재능 유형으로), 명단을 조직<br />
                    • 자료 2. (가상) 문화공간 건립 계획서 (Worksheet 1 – 4)<br />
                    • 자료 3. 또래평가지: 다른 팀의 ‘문화공간 건립 계획서’
                    평가에 사용할 ‘건립 계획서 평가지’ (Worksheet. 5)
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line">
              <li>
                결과물<br />
                + PUTT2.0 결과리포트<br />
                + 팀 과업 제안서
              </li>
              <li>
                <dl class="line2">
                  <dt>구성</dt>
                  <dd>
                    • 모듈 1. [사전 진단] PUTT2.0 - 1주일 전 - On-Line 실시 – 팀
                    배치<br />
                    • 모듈 2. [강의] (1) PUTT2.0 결과 – 재능별/직업군별 사례 소개,
                    (2) 과제 소개 및 안전 교육<br />
                    • 모듈 3. [과제 수행] (1) 팀별 구성원(구성원 각자가 특정
                    분야 전문가임) 소개, (2) 문화공간 검색<br />
                    (3) 공간 종류 및 개념/가치 설정, (4) 공간 개요/설계, (5)
                    구성원별 직무 및 조직 구성, 세부 내용 구성<br />
                    • 모듈 4. [계획서 작성] 계획서 작성, 팀 발표, 또래평가
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line">
              <li>진행: 관리자</li>
              <li>
                <dl class="line2">
                  <dt>활용</dt>
                  <dd>
                    “자유학기제”를 통해 학생의 타고난 재능에서 관심, 학습,
                    성취의지, 진로 선택까지 동일선상에서<br />
                    체계적, 총체적 데이터를 수집, 분석하여 이를 중장기적 학습
                    설계에 유용하게 활용할 수 있다.
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div class="btn">
            <router-link :to="`${USER_ROUTES.Product.Activity.Talent.Path}`"
              >목록</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.menu-A-read-wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  word-break: keep-all;
  box-sizing: border-box;
}
.menu-A-read-wrap > div h1 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
}
.menu-A-read-wrap > div ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.menu-A-read-wrap > div ul.box22 {
  padding: 20px 0;
}
.menu-A-read-wrap > div ul li {
  width: 100%;
  font-size: 14px;
  line-height: 1.7em;
}

.menu-A-read-wrap > div ul li:nth-child(1) {
  padding: 20px 0;
  border-bottom: 1px solid #ddd;
}
.menu-A-read-wrap > div ul li dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 22px 0;
  border-bottom: 1px solid #ddd;
}

.menu-A-read-wrap > div ul li dl dt {
  width: 100%;
  margin-bottom: 10px;
}
.menu-A-read-wrap > div ul li dl dd {
  line-height: 1.7em;
  width: 100%;
}

.menu-A-read-wrap div.btn {
  margin-top: 50px;
  text-align: center;
}
.menu-A-read-wrap div.btn a {
  display: inline-block;
  text-align: center;
  font-size: 15px;
  background: #fff;
  color: #004e31;
  padding: 5px 25px;
  transition: all 0.2s;
  border: 1px solid #004e31;
  font-weight: 500;
}

@media (min-width: 768px) {
  .menu-A-read-wrap > div ul li dl {
    align-items: center;
  }
  .menu-A-read-wrap > div ul li dl.line3 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul.line {
    border-bottom: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li dl.line2 {
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul.line4 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 180px;
    padding: 0;
    text-align: center;
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 200px);
  }
  .menu-A-read-wrap > div ul li {
    font-size: 15px;
  }
  .menu-A-read-wrap > div ul li dl dt {
    width: 80px;
    margin-bottom: 0;
  }
  .menu-A-read-wrap > div ul li dl dd {
    line-height: 1.7em;
    width: calc(100% - 90px);
  }
}

@media screen and (min-width: 1100px) {
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 270px;
    padding: 0;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 320px);
  }
}
</style>
